import { createContext, useContext, useState, useCallback } from "react";
import { getPwsIdCookie } from "../../utilities/commonFunctions/pwsIdCookie";

const ModalContext = createContext();

export const WaterSystemSearchModalProvider = ({ children, menuItemsArray = [] }) => {
  const [showSystemSelectModal, setShowSystemSelectModal] = useState(false);
  const [selectedWaterSystem, setSelectedWaterSystem] = useState(
    sessionStorage.getItem("selectedWaterSystem")
      ? JSON.parse(sessionStorage.getItem("selectedWaterSystem"))
      : null
  );
  const [isRestoringFromCookie, setIsRestoringFromCookie] = useState(
    !sessionStorage.getItem("selectedWaterSystem") && !!getPwsIdCookie()
  );

  /**
   * Recursively searches through menu items to find one matching the given code
   * @param {string} code - The code to search for (looks in item.code property)
   * @param {array} items - Menu items to search through (defaults to menuItemsArray)
   * @returns {object|null} - The matching menu item or null if not found
   */
  const findMenuItemByCode = useCallback((code, items = menuItemsArray) => {
    if (!Array.isArray(items)) return null;

    for (const item of items) {
      // Check if this item matches the code
      if (item.code === code) {
        return item;
      }
      // Recursively check children
      if (item.children && Array.isArray(item.children)) {
        const found = findMenuItemByCode(code, item.children);
        if (found) return found;
      }
    }
    return null;
  }, [menuItemsArray]);

  return (
    <ModalContext.Provider value={{
      showSystemSelectModal,
      setShowSystemSelectModal,
      selectedWaterSystem,
      setSelectedWaterSystem,
      isRestoringFromCookie,
      setIsRestoringFromCookie,
      findMenuItemByCode,
      menuItemsArray
    }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useWaterSystemSearchModal = () => useContext(ModalContext);